import { startOfDay } from 'date-fns';

/**
 * Verifica se o array de visitas agendadas (visitsSchedule) satisfaz
 * o array de visitas requeridas (requiredSchedule) para cada dia.
 * @param {Array<Object>} updatedSchedulingEvents Array de eventos atualizados com a última modificação do formulário.
 * @param {Array<{date: string, total: number}>} requiredSchedule Array de visitas esperadas com campos "date" (YYYY-MM-DD) e "total".
 * @returns {{isScheduleComplete: boolean, scheduleReport: Array<{date: string, totalRequired: number, totalScheduled: number, status: string}>}} Resultado da verificação.
 */
function _findScheduleReport(updatedSchedulingEvents, requiredSchedule) {
  // ===========================================================
  // --- 1. Conta as visitas agendadas por data (YYYY-MM-DD) ---
  // ===========================================================
  // Array de visitas reais agendadas com campo "start" (ISO String: YYYY-MM-DDTHH:mm:ss.sssZ).
  const visitsSchedule = [];

  // eslint-disable-next-line no-unused-vars
  for (const schedulingEvent of updatedSchedulingEvents) {
    const { periodsForVisit } = schedulingEvent;

    visitsSchedule.push(...periodsForVisit);
  }

  const scheduledCountMap = new Map();

  visitsSchedule.forEach(visit => {
    const date = startOfDay(new Date(visit.start)).toISOString();
    scheduledCountMap.set(date, (scheduledCountMap.get(date) || 0) + 1);
  });

  // ==================================================================
  // --- 2. Compara com o agendamento requerido e gerar o relatório ---
  // ==================================================================
  const scheduleReport = [];
  let isScheduleComplete = true;

  requiredSchedule.forEach(requiredDay => {
    const date = startOfDay(new Date(requiredDay.date)).toISOString();
    const totalRequired = requiredDay.total;
    const totalScheduled = scheduledCountMap.get(date) || 0;

    let status;
    if (totalScheduled >= totalRequired) {
      status = 'Completo';
    } else {
      status = `Incompleto (Faltam ${totalRequired - totalScheduled})`;
      isScheduleComplete = false;
    }

    scheduleReport.push({
      date,
      totalRequired,
      totalScheduled,
      status
    });
  });

  // ==============================
  // --- 3. Retorna o resultado ---
  // ==============================
  return { isScheduleComplete, scheduleReport };
}

export { _findScheduleReport };
